export const RESET = 'EXCMCUSTOMFIELD_LIST_RESET'
export const SET_ITEMS = 'EXCMCUSTOMFIELD_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCUSTOMFIELD_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCUSTOMFIELD_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCUSTOMFIELD_LIST_TOGGLE_LOADING'
